import { HttpService } from 'http/httpService'
import { ArticleFromApi, UpgradeableProduct } from 'products/types'
import { fetchFullyCursorPaginatedData } from 'utils/fetchFullyPaginatedData'
import { CursorPaginatedResponse } from '../../types'

export class ProductsService {
    constructor(private httpService: HttpService, private backofficeEndpoint: string) {}

    private async getArticleBatch(articles_path: string): Promise<CursorPaginatedResponse<ArticleFromApi>> {
        let response = await this.httpService.fetch(`${this.backofficeEndpoint}${articles_path}`)

        if (!response.ok) {
            throw new Error('Unable to fetch articles')
        }
        return await response.json()
    }

    async listProducts(accountSlug: string): Promise<ArticleFromApi[]> {
        const params = new URLSearchParams({ account: accountSlug, include: 'name,categories,resources' }).toString()
        const data = await fetchFullyCursorPaginatedData<ArticleFromApi>({
            fetchData: async ({ cursor }) => await this.getArticleBatch(cursor || `api/v1/products/?${params}`),
        })
        return data
    }

    async listSeasonPasses(accountSlug: string): Promise<UpgradeableProduct[]> {
        const response = await this.httpService.fetch(
            `${this.backofficeEndpoint}api/v1/accounts/${accountSlug}/articles/filtered?business_type=season_pass,multi_visit_ticket,upsell`,
        )

        if (!response.ok) {
            throw new Error('Unable to fetch season passes')
        }

        const data = await response.json()
        return data
    }
}
